module.exports = __webpack_public_path__ + "static/eliezer-f533af7d3245d54c8ebf7d3a3829cc79.png";